import axios from 'axios';

import acknowledgeNotificationDTO from '../types/acknowledgeNotificationDTO';
import getNotificationDTO from '../types/getNotificationDTO';

export const getNotification = (payload: getNotificationDTO) =>
  axios.post('notificationengine/api/notifications', payload);

export const getUnreadCount = () => axios.get('notificationengine/api/notifications/unread');

export const acknowledgeNotification = (payload: acknowledgeNotificationDTO) =>
  axios.put('notificationengine/api/notifications/acknowledge', payload);

export const acknowledgeNotificationMultiple = (payload: acknowledgeNotificationDTO[]) =>
  axios.put('notificationengine/api/notifications/acknowledge-multiple', payload);
